// Constantes do formulário Self Service

export const FORM_DEFAULT_VALUES = {
  accessCode: "",
};

export const FORM_FIELD_NAMES = {
  ACCESS_CODE: "accessCode",
};

export const LOGO_URLS = {
  INFORMA_MARKETS:
    "https://cdn.asp.events/CLIENT_AEO_6F6DAB1E_5056_B739_5434FCD30E5F9143/companyProfiles/BC678F0-2D4B-472A-B99E-71984460A509-logo.png",
  MOCK_LOGO:
    "https://empresariodigital.com.br/wp-content/uploads/2025/02/1500322460660.png",
};

export const CODE_ACCEPT = "33j"; // Código de acesso aceito para teste
